/**
 * 公式的http请求对象
 * */

import axios from 'axios';
import qs from 'qs';
import apiList from './api';
import Sign from './sign';
import rsa from './rsa';
import store from '../../store';
import config from '../../config/config';

const IsProduct = process.env.NODE_ENV === 'product';


let api_url = config.api_url;
let new_api_url = config.new_api_url;

// axios 配置
const axiosConfig = {
  baseURL: config.api_url,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
};

// 加/解密对象
const sign = {
  // 解密
  decode: e => {
    return Sign.decode_post(e);
  },
  // 加密
  encode: e => {
    Sign.params = e;
    return Sign.encode_post();
  }
};

// 加载中弹出层
const load = {
  // 打开弹出层
  open: () => {
    console.log('open');
  },
  // 关闭弹出层
  close: (isAll = false) => {
    if (isAll) {
      console.log('close all');
    } else {
      console.log('close');
    }
  },
};

function initData(data) {
  let out = Object.assign({
    is_https: +(location.protocol === 'https:') || '',
    is_web: 1
  }, data);
  Object.keys(out).map(k => {
    if (!out[k] && out[k] !== 0) delete out[k];
  });
  return out;
}

function initConfig(config) {
  let out = Object.assign({
    isSign: false, // 是否需要加密
    loading: true, // 是否显示loading
    needXToken: true, // 是否需要xToken
    resDataKey: 'data', // 返回数据内容的key
  }, axiosConfig, config);

  out.headers = Object.assign({
    ...axiosConfig.headers
  }, out.headers);
  // out.headers['x-token'] = out.needXToken ? store.getters.xToken : '';

  return out;
}

// 是否正确返回
function isSuccessRes(res) {
  return res.code * 1 === config.ERR_OK;
}

class Index {

  _axios = axios;
  hasCancelList = ['cancelList', 'routerCancelList'];
  cancelList = {};
  routerCancelList = {};

  http(url = '', data = {}, config = {}, method = 'post') {
    let params = initData(data);
    config = initConfig(config);
    params['token'] = config.needXToken ? store.getters.oldToken : '';
    let {isSign, loading, resDataKey, isTest, needCancel} = config;
    delete config.isSign;
    delete config.loading;
    delete config.resDataKey;
    delete config.needXToken;
    delete config.isTest;
    delete config.needCancel;
    let oldData = params;
    let cancelKey = url + JSON.stringify(params);
    
    isSign && (params = JSON.parse(sign.encode(params)));
    loading && load.open();

    needCancel === 'left' && this.$cancel(cancelKey);
    needCancel === 'url' && this.$cancel(url);
    if (needCancel === 'right' && this.cancelList[cancelKey]) {
      throw new Error('http cancel');
    }

    config.cancelToken = new axios.CancelToken(r => {
      needCancel && (this.cancelList[cancelKey] = r);
      needCancel === 'router' && (this.routerCancelList[cancelKey] = r);
    })

    // params = qs.stringify(params);
    return axios[method](url, params, config).then(res => {
      let result = isSign ? sign.decode(res.data) : res.data;
      isTest && !IsProduct && console.log(url, '\n\t', JSON.stringify(oldData), '\n\t', JSON.stringify(result));
      if (isSuccessRes(result)) {
        return resDataKey ? result[resDataKey] : result;
      } else {
        IsProduct || console.log('url:\n\t', url, '\nparmas:\n\t', JSON.stringify(oldData), '\nerr:\n\t', result);
        throw result;
      }
    });
  }

  async upload(url, params = {}, config = {}) {
    let conf = {
      headers: {
        'Content-Type': 'multipart/form-data;',
      },
    };
    if (params.file) {
      let form = new FormData();
      form.append(params.fileName || 'file', params.file);
      params.data && Object.keys(params.data).forEach(k => form.append(k, params.data[k]));
      Object.assign(conf.headers, config.headers);
      delete config.headers;
      Object.assign(conf, config);
      return await axios.post(url, form, conf);
    }
    throw {code: 4, msg: '没有找到文件！'}
  }

  post(url, data, config) {
    return this.http(url, data, config, 'post');
  }

  get(url, data, config) {
    return this.http(url, data, config, 'get');
  }

  test(...arg) {
    let [url, data, config, method] = arg;
    let configs = initConfig(Object.assign({...config}, {
      loading: false,
      resDataKey: '',
    }));
    let out = {};
    method = method || 'post';
    console.log(url, ':data:>', data);
    console.log(url, ':initData:>', initData(data));
    console.log(url, ':config:>', config);
    console.log(url, ':initConfig:>', initConfig({...config}));
    this.http(url, data, configs, method).then(res => {
      console.log(url, ':res:>', res);
      Object.assign(out, res);
      if (!Object.keys(out).length) out.status = true;
    }).catch(err => {
      Object.assign(out, err);
      if (!Object.keys(out).length) out.status = false;
      console.log(url, ':error:>', err);
    });
    return out;
  }

  $post(url, data, config) {
    config = config || {};
    config.isSign = true;
    return this.post(url, data, config);
  }

  download(url, params = {}, config = {}) {
    Object.keys(params).map(e => {
      // 去掉空的参数
      if (!params[e] && params[e] !== 0) {
        delete params[e];
      }
    });
    let data = params;
    if (config.isSign) {
      data = JSON.parse(sign.encode(params));
    }
    if (config.needXToken) {
      data['X-token'] = store.getters.xToken;
    }
    let pathData = [];
    Object.keys(data).map(k => {
      pathData.push(`${k}=${data[k]}`);
    });
    let api = /^https?/.test(url) ? '' : api_url;
    return api + url + '?' + pathData.join('&');
  }

  $err(err, tvm) {
    // 错误处理
    load.close(true);
    if (err.message !== 'http cancel' && err.message !== 'Request aborted') {
      this.ShowToast(err.msg || '网络错误！', tvm);
      if(err.code === 401){
        store.commit('setNewApiToken', '');
        store.commit('setOldToken', '');
        store.commit('setUserInfo', {});
        setTimeout( () => { location.reload(); }, 1000);
      }
      // this.$Message.error({
      //   content: err.msg || '网络错误！'
      // })
    }
    console.log(err);
  }

  sleep(time, isPromise = true) {
    for (let end = +new Date() + +time; end > +new Date();) {
      if (isPromise) {
        return new Promise(resolve => {
          setTimeout(resolve, time);
        });
      }
    }
  }

  async $getToken(res = store.state.userInfo) {
    let r = await http.$post1('login/Api/get_token', {
      ...res,
      ...store.state.productInfo,
    }, {
      needToken: false,
      needCancel: false
    });
    store.commit('setNewApiToken', r.access_token);
  }

  $cancel(key, cancelKey = 'cancelList') {
    let msg = 'http cancel';
    let lists = http.hasCancelList;
    if (!lists.includes(cancelKey)) return;
    if (key) {
      for (let k in this[cancelKey]) {
        if (!k.indexOf(key)) {
          this[cancelKey][k] && this[cancelKey][k](msg);
          lists.forEach(ck => {
            delete this[ck][k];
            delete this[ck][k];
          });
        }
      }
    } else {
      Object.values(http[cancelKey]).forEach(fn => fn(msg));
    }
  }

  async $post1(url, params = {}, config = {}) {
    let apiUrl = new_api_url;
    url = url.replace(/^\/?api2?\//ig, '');
    params = initData(params);
    !Object.keys(params).length && (params.accesskey = 'Z8JaIBi9SnrkVd2dPMncnBfImMlkWwbB');
    rsa.params = params;
    let reqData = {params: rsa.create_data_rsa()};
    let loading = config.isLoad !== false;
    let needToken = config.needToken !== false;
    let needCancel = config.needCancel;
    let returnAll = config.returnAll;
    let isTest = config.isTest;
    delete config.isLoad;
    delete config.needToken;
    delete config.needCancel;
    delete config.returnAll;
    delete config.isTest;
    loading && load.open();
    try {
      let res = null;
      let data = {};
      let forCount = 5;
      let cancelKey = url + reqData.params;
      needCancel === 'url' && this.$cancel(url);
      needCancel === 'left' && this.$cancel(cancelKey);
      if (needCancel === 'right' && this.cancelList[cancelKey]) {
        throw new Error('http cancel');
      }
      // do {
      //   if (res || needToken && !store.getters.newApiToken) {
      //     try {
      //       res && await this.sleep(1000);
      //       await this.$getToken();
      //     } catch (error) {
      //       console.log(error);
      //     }
      //   }
      res = await axios.post(url, reqData, {
        baseURL: apiUrl,
        headers: {
          'x-token': needToken ? store.getters.newApiToken : ''
        },
        cancelToken: new axios.CancelToken(r => {
          needCancel && (this.cancelList[cancelKey] = r);
          needCancel === 'router' && (this.routerCancelList[cancelKey] = r);
        }),
        ...config
      });
      data = res.data;
      forCount--;
      // } while (+data.code === 401 && data.msg === '您的账号在其他设备登录，请重新登录。' && forCount > 0);
      forCount <= 0 && location.reload(true);
      this.hasCancelList.forEach(ck => delete http[ck][cancelKey]);
      loading && load.close();
      isTest && !IsProduct && console.log(url, '\n\t', JSON.stringify(params), '\n\t', JSON.stringify(data));

      // 处理异常响应格式（如 {time: ...}）
      if (data && data.time && !data.code) {
        console.warn('[HTTP] 接口返回异常格式，可能是限流或 Session 过期:', url, data);
        throw Object.assign(new Error('接口返回异常格式'), { response: data, isAbnormalFormat: true });
      }

      if (isSuccessRes(data)) return returnAll ? data : (data.data || data.msg);
      // if (+data.code === 401) {
      //   if(store.getters.newApiToken){
      //     store.commit('setNewApiToken', '');
      //     store.commit('setOldToken', '');
      //     store.commit('setUserInfo', {});
      //     setTimeout( () => { location.reload(); }, 2000);
      //   }
      // }
      throw data;
    } catch (error) {
      IsProduct || console.log('url:\n\t', url, '\nparmas:\n\t', JSON.stringify(params), '\nerr:\n\t', error);
      loading && load.close();
      throw error;
    }
  }
}

let http = new Index();
Object.assign(http, apiList(http));
export default http;